import Image from '@components/elements/image/image';
import { isKeyOf, Maybe } from '@crocodille/util';
import glutenfreeImage from './assets/glutenfree.png';
import lactosefreeImage from './assets/lactosefree.png';
import nosugarImage from './assets/nosugar.png';
import veganImage from './assets/vegan.png';
import vegetarianImage from './assets/vegetarian.png';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './product-tags.module.scss';

const IMAGE_MAP = {
  glutenfree: glutenfreeImage,
  lactosefree: lactosefreeImage,
  nosugar: nosugarImage,
  vegan: veganImage,
  vegetarian: vegetarianImage,
} as const;

export interface ProductTagsProps {
  readonly inset?: boolean;
  readonly tags: string[];
  readonly className?: Maybe<string>;
}

const ProductTags: React.FC<ProductTagsProps> = ({
  tags,
  inset,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <ul
      className={cn(styles.container, {
        [styles.isInset]: inset,
      })}
    >
      {tags
        .map((t) => t.toLowerCase())
        .map((tag) =>
          isKeyOf(tag, IMAGE_MAP) ? (
            <li key={tag} className={cn(styles.tag, className)}>
              <Image src={IMAGE_MAP[tag]} alt={t(`product.tag.${tag}`)} />
            </li>
          ) : null,
        )}
    </ul>
  );
};

export default ProductTags;
